import { render, staticRenderFns } from "./EditPhone.vue?vue&type=template&id=4213da74&scoped=true&"
import script from "./EditPhone.vue?vue&type=script&lang=js&"
export * from "./EditPhone.vue?vue&type=script&lang=js&"
import style0 from "./EditPhone.vue?vue&type=style&index=0&id=4213da74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213da74",
  null
  
)

export default component.exports